let swiper;

function init_index() {

  initSwipers();
  


  //--- initSections
  initSpace();
  initFree();
  //--- initSections END

  // initLoad();

  // initPop();

  initTopBtn();

  initGA();
  initVideo();
  initAni();

  

}
function initTopBtn() {
  $('.topBtn').on('click', () => {
    gsap.to(window, {
      duration: 1,
      scrollTo: 0
    })
  })

  gsap.from($('.topBtn'), {
    duration: 0.8,
    x: '200',
    ease: Back.easeOut.config(1.3),
    scrollTrigger: {
      trigger: 'body',
      start: 'top -200',
      toggleActions: 'play none none reverse',
    },
  })
}

function initGA() {

  $('.gBtn').on('click', (e) => {
    let t = $(e.currentTarget);
    let event = t.attr('data-g');
    console.log('click-event:'+event);
    gtag('event', 'click', {
      'value': event
    });
  })
  
  $('.urlWrap').each((index, el) => {
    let start = (index == 0) ? 'top top' : 'top center';
    let end = (index == $('.urlWrap').length - 1) ? 'bottom bottom' : 'bottom center';
    ScrollTrigger.create({
      trigger: el,
      start: start,
      end: end,
      // markers: true,
      onEnter: self => {
        console.log('page_view:' + self.trigger.dataset.url)
        history.pushState({}, null, `\#${self.trigger.dataset.url}`);
        gtag('event', 'page_view', {
          page_path: self.trigger.dataset.url
        });
      },
      onEnterBack: self => {
        console.log('page_view:' + self.trigger.dataset.url)
        history.pushState({}, null, `\#${self.trigger.dataset.url}`);
        gtag('event', 'page_view', {
          page_path: self.trigger.dataset.url
        });
      },
    });
  })

}


function initVideo() {
  console.log
  $('video').each((index,el)=>{
    var t = $(el);
    var src = (!ChungTool.isPhone())?t.attr('data-pc'):t.attr('data-m');
    if(src){
      t.append(`<source src="./video/${src}" type="video/mp4" />`);
    }
    el.play();

  })
}




function initSwipers() {
  // rtb
  swiper = new Swiper('#feature-swiper', {
    pagination: {
      el: '#feature-swiper .swiper-pagination',
      clickable: true,
    },
    // loop: true,
    speed: 600,
    // autoplay: {
    //   delay: 3000,
    // },
    navigation: {
      nextEl: '#feature-swiper .swiper-button-next',
      prevEl: '#feature-swiper .swiper-button-prev',
    },
    on: {
      slideChangeTransitionStart: function (swiper) {
        console.log(this.activeIndex);
        $('#feature .tags .tag').eq(this.realIndex).addClass('active').siblings('.tag').removeClass('active');
        const video = $(swiper.slides[swiper.activeIndex]).find('video').get(0);
        video.pause();
        video.currentTime = '0';
        video.play();

      },
      slideChangeTransitionEnd: function (swiper) {
        // $('#feature .tags .tag').eq(this.realIndex).addClass('active').siblings('.tag').removeClass('active');
      },
    }
  });

  $('#feature .tags .tag').on('click',(e)=>{
    var index = $(e.currentTarget).index();
    swiper.slideToLoop(index)
  })

  

  const swiper2 = new Swiper('#free .swiper-container', {
    spaceBetween: 200,
    on: {
      slideChangeTransitionStart: function (swiper) {
        $('#free .tabs .tab').eq(this.realIndex).addClass('active').siblings('.tab').removeClass('active');
        const video = $(swiper.slides[swiper.activeIndex]).find('video').get(0);
        video.pause();
        video.currentTime = '0';
        video.play();
      },
      touchStart: function () {
        gsap.set($('#free .swiper-slide:not(.swiper-slide-active) .ani'), {
          alpha: 0,
          y: 30
        })
      },
      transitionStart: function () {
        gsap.set($('#free .swiper-slide.swiper-slide-active .ani'), {
          alpha: 0,
          y: 30
        })
      },
      transitionEnd: function () {
        gsap.to($('#free .swiper-slide.swiper-slide-active .ani'), {
          duration: .6,
          alpha: 1,
          stagger: 0.1,
          y: 0
        })
        // console.log( $(swiper.slides[swiper.activeIndex]).find('video')[0]);
        // $(swiper.slides[swiper.activeIndex]).find('video')[0].pause();
      },
    }
  });
  $('#free .tabs .tab').on('click',(e)=>{
    var index = $(e.currentTarget).index();
    swiper2.slideToLoop(index)
  })
}



function initAni() {
  // circle ani
  // gsap.to('.circle-ani', {
  //   duration: 6,
  //   rotation: 360,
  //   repeat: -1,
  //   ease: "none"
  // })

  // // shine ani
  // gsap.to('.shine-ani', {
  //   duration: .8,
  //   opacity: 0,
  //   repeat: -1,
  //   ease: "none",
  //   yoyo: true,
  //   repeatDelay: .8
  // })

  // gsap.to('.shine-ani2', {
  //   duration: .7,
  //   scale: 0.98,
  //   opacity: 0.7,
  //   repeat: -1,
  //   yoyo: true
  // })

  // from b
  $('.ani-f-b').each((index, el) => {
    gsap.from(el, {
      duration: .8,
      y: '+50',
      opacity: 0,
      ease: Power4.out,
      scrollTrigger: {
        trigger: el,
        start: 'top bottom-=200',
      }
    })
  });

  // from b
  $('.ani-f-b-stagger').each((index, el) => {
    gsap.from($(el).find('.ani'), {
      duration: .8,
      y: '+50',
      opacity: 0,
      stagger: 0.15,
      ease: Power4.out,
      scrollTrigger: {
        trigger: el,
        start: 'top bottom-=200',
      }
    })
  });

  // title ani
  $('.scrollTitle-ani').each((index, el) => {
    gsap.from($(el).find('.ani'), {
      duration: 1.2,
      alpha: 0,
      scale: 1.2,
      stagger: 0.15,
      ease: "elastic.out(1,0.5)",
      scrollTrigger: {
        trigger: el,
        start: 'top bottom-=200',
      }
    })
  });


  $('.lineWrap').each((index, el) => {
    gsap.from($(el), {
      duration: 1.2,
      x: '-50%',
      alpha: 0,
      ease: "Power1.easeOut",
      scrollTrigger: {
        trigger: el,
        start: 'top bottom-=200',
      }
    })

    gsap.from($(el).find('.line'), {
      duration: 2,
      x: '-100%',
      ease: "Power1.easeOut",
      scrollTrigger: {
        trigger: el,
        start: 'top bottom-=200',
      }
    })
  });

  // egg
  gsap.from('.egg', {
    y: (ChungTool.isPhone())?-300:-100,
    scrollTrigger: {
      trigger: '#safe .picWrap',
      scrub: 1,
      start: 'top center-=150',
      end: "center center-=150",
    }
  })

}


function initSpace() {
  let space = $('#space');
  space.find('.tabs .tab').on('click', (e) => {
    let t = $(e.currentTarget);
    t.addClass('active').siblings('.tab').removeClass('active');
    space.find('.picWrap').addClass('hide')
    simpleShow(space.find(`.picWrap`).eq(t.index()))
  })
}


function initFree() {
  $('#free .popBtn').on('click',(e)=>{
    var t = $(e.currentTarget);
    var src = t.attr('data-pic');
    console.log('src: ', src);
    Swal.fire({
      imageUrl: `./images/${src}`,
      width: (ChungTool.isPhone())?600:800,
      showClass: {
        popup: 'fadeIn'
      },
      confirmButtonText: '',
      customClass: {
        confirmButton: 'closeBtn',
      }
    })
  })
}